<template>
  <router-view />
</template>
<script setup>
// console.log(document.body.dataset.theme);
import store from '@/store'
import { onMounted, onUnmounted } from 'vue'
// 移动端适配：用 props 控制宽度/全屏，避免 teleport 或内联样式导致 CSS 不生效
const handleResize = () => {
  store.commit('SET_ISMOBILE', window.innerWidth <= 768)
};
onMounted(() => {
  handleResize();
  window.addEventListener("resize", handleResize);
});
onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});

</script>
<style>
html,
body,
#app {
  height: 100%;
}

.light {
  background-color: #fff !important;
  color: rgba(0, 0, 0, 0.9);
}

.dark {
  background-color: #1b1b1b !important;
  color: #fff;
}

.app-container {
  padding: 20px;
}

/* 加载进度条颜色 */
#nprogress .bar {
  background: rgb(71, 221, 34) !important;
}

/* 加载icon 颜色 */
#nprogress .spinner-icon {
  border-top-color: rgb(93, 221, 34) !important;
  border-left-color: rgb(71, 221, 34) !important;
}
</style>
